// extracted by mini-css-extract-plugin
module.exports = {"content":"Author_content__BEy7F","img":"Author_img__3t0g_"};